var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input", {
        attrs: { disabled: _vm.disabled, placeholder: "请选择红包池" },
        nativeOn: {
          click: function ($event) {
            return _vm.openModal.apply(null, arguments)
          },
        },
        model: {
          value: _vm.value.redPoolAccountName,
          callback: function ($$v) {
            _vm.$set(_vm.value, "redPoolAccountName", $$v)
          },
          expression: "value.redPoolAccountName",
        },
      }),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }